// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:1024px){.wapTextLeft[data-v-39b1aa44]{text-align:left!important}}", ""]);
// Exports
module.exports = exports;
